import { Stack } from 'expo-router';
import React from 'react';

function ReactivationLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default ReactivationLayout;
